import React from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import FormulaireReinitialiserMotDePasse from '../composants/formulaires/FormulaireReinitialiserMotDePasse';

const ReinitialiserMotDePasseContainer = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const token = searchParams.get('token') || '';

    const fermeture = () => {
        navigate('/');
    };

    return (
        <FormulaireReinitialiserMotDePasse
            ouvert={true}
            fermeture={fermeture}
            token={token}
        />
    );
};

export default ReinitialiserMotDePasseContainer;
